import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { SchoolFilter as SchoolFilterModel, SchoolFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const SchoolFilter = (props: { filter: SchoolFilterModel; setFilter: (value: SchoolFilterModel) => void }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<SchoolFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.schools.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const inactiveField = () => {
    const propertyName = pn<SchoolFilterModel>("inactive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS?.find((x) => x.id === props.filter.inactive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.inactive = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {inactiveField()}
      </Grid>
    </Grid>
  );
};
